import { LatLngBoundsLiteral } from "leaflet";

import { IPath } from "Types/path";

import { setAppData } from "Redux/appSlice";
import { setMapData } from "Redux/mapSlice";
import { changeMenu } from "Redux/menuSlice";
import { changeOperation } from "Redux/operationSlice";
import { setPoints } from "Redux/pointsSlice";
import { setStations } from "Redux/stationsSlice";
import { starDashboardVisibility } from "Redux/servicesSlice";

import { useAppDispatch } from "./useRedux";

export default function useEditPath() {
  const dispatch = useAppDispatch();

  const showPathOnMap = (path: IPath) => {
    const positions: LatLngBoundsLiteral = path.points.map((point) => [point.lat, point.lng]);

    dispatch(changeMenu("disable"));
    dispatch(setMapData({ bounds: { positions } }));
  };
  const editPath = (path: IPath) => {
    dispatch(setStations(path.stations));
    dispatch(setPoints(path.points));
    dispatch(starDashboardVisibility(true));

    dispatch(changeOperation({ name: "edit-path", type: path.type }));
    dispatch(setAppData({ path: { ...path } }));
    dispatch(changeMenu("disable"));
    // showPathOnMap(path);
  };

  return { showPathOnMap, editPath };
}
